import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const variantesBotao = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/60 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        padrao: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90',
        destrutivo: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        contorno: 'border border-input bg-card hover:bg-secondary hover:text-secondary-foreground',
        secundario: 'bg-secondary text-secondary-foreground hover:bg-secondary/70',
        fantasma: 'hover:bg-secondary hover:text-secondary-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      tamanho: {
        // Alvos maiores no celular (40 px) e o tamanho de sempre a partir de `sm`.
        padrao: 'h-10 px-4 py-2 sm:h-9',
        pequeno: 'h-9 rounded-md px-3 text-xs sm:h-8',
        grande: 'h-11 rounded-lg px-6 text-base',
        icone: 'size-10 sm:size-9',
      },
    },
    defaultVariants: {
      variant: 'padrao',
      tamanho: 'padrao',
    },
  },
);

export interface BotaoProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof variantesBotao> {
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, BotaoProps>(
  ({ className, variant, tamanho, asChild = false, ...props }, ref) => {
    const Componente = asChild ? Slot : 'button';
    return (
      <Componente className={cn(variantesBotao({ variant, tamanho }), className)} ref={ref} {...props} />
    );
  },
);
Button.displayName = 'Button';
